import { SVGProps } from 'react';

const IcTime = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none' {...props}>
      <path
        d='M7.99992 14.6666C6.68138 14.6666 5.39245 14.2757 4.29612 13.5431C3.19979 12.8106 2.34531 11.7694 1.84072 10.5512C1.33614 9.33303 1.20412 7.99259 1.46135 6.69938C1.71859 5.40617 2.35353 4.21829 3.28588 3.28594C4.21823 2.35359 5.40611 1.71865 6.69932 1.46141C7.99252 1.20418 9.33297 1.3362 10.5511 1.84079C11.7693 2.34537 12.8105 3.19985 13.543 4.29618C14.2756 5.39251 14.6666 6.68144 14.6666 7.99998C14.6666 9.76809 13.9642 11.4638 12.714 12.714C11.4637 13.9643 9.76803 14.6666 7.99992 14.6666ZM7.99992 2.2857C6.86974 2.2857 5.76494 2.62083 4.82523 3.24873C3.88552 3.87662 3.15311 4.76907 2.72061 5.81322C2.28811 6.85737 2.17495 8.00632 2.39543 9.11478C2.61592 10.2232 3.16015 11.2414 3.95931 12.0406C4.75847 12.8397 5.77666 13.384 6.88512 13.6045C7.99358 13.825 9.14253 13.7118 10.1867 13.2793C11.2308 12.8468 12.1233 12.1144 12.7512 11.1747C13.3791 10.235 13.7142 9.13016 13.7142 7.99998C13.7142 6.48446 13.1122 5.03101 12.0405 3.95937C10.9689 2.88774 9.51544 2.2857 7.99992 2.2857Z'
        fill='#566A7F'
      />
      <path
        d='M10.1856 10.8571L7.52373 8.19522V3.71427H8.47611V7.79998L10.8571 10.1857L10.1856 10.8571Z'
        fill='#566A7F'
      />
    </svg>
  );
};

export default IcTime;
